<template>
    <div class="width100">
        <vue-confirm-dialog></vue-confirm-dialog>

        <Aide v-bind:token="token" v-bind:site="site" v-bind:racine="racine"
              v-bind:user="user" v-bind:idAide="11"></Aide>

        <h3 class="titreSolu text-center">Déclaration carburant</h3>


        <div v-if="errors.length" class="alert alert-danger text-center" role="alert">
            <p v-for="(error, key) in errors" :key="key">{{ error }}</p>
        </div>
        <div v-if="msgs.length" class="alert alert-success text-center" role="alert">
            <p v-for="(msg, key) in msgs" :key="key">{{ msg }}</p>
        </div>

        <h3 class="titreSolu text-center" v-if="niveau==1">De quel type de véhicule s'agit il?</h3>
        <p class="text-center text-warning" v-if="niveau==1">Cette liste est classée par votre fréquence d'utilisation.</p>
        <div v-if="niveau == 1" class="row">
            <div class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachineType(1)">
                    Tracteur
                </div>
            </div>
            <div class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachineType(3)">
                    Remorque
                </div>
            </div>
            <div class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachineType(2)">
                    Voiture
                </div>
            </div>
        </div>

        <h3 class="titreSolu text-center" v-if="niveau==2">De quel véhicule il s'agit ?</h3>
        <p class="text-center text-warning" v-if="niveau==2"></p>
        <div v-if="niveau == 2 && machineType==3" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(remorque, keyRem) in listRemorque" :key="keyRem" class="colSolu col-md-12 col-lg-4">
                <div class="thtab userList col-12 text-center rounded"
                     @click="choixMachine(remorque)">
                    {{remorque.numero}}
                </div>
            </div>
        </div>
        <div v-if="niveau == 2 && (machineType==1 ||machineType==2)" class="row" style="overflow: scroll;height:250px;">
            <div v-for="(camion, keyCam) in listCamion" :key="keyCam" class="colSolu col-md-12 col-lg-4">
                <div v-if="camion.typeVehicule==machineType" class="thtab userList col-12 text-center rounded"
                     @click="choixMachine(camion)">
                    {{camion.nom}}
                </div>
            </div>
        </div>


        <div v-if="niveau == 3">
            <div v-if="idUserLingevres>0">


                <div>
                    <div class="row">
                        <div class="col-6">
                            Date
                        </div>
                        <div class="col-6">
                            <input type="date" class="form-control"  v-model="date"> <!--@change="getConsoByDate()"-->
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-6">
                            Véhicule
                        </div>
                        <div class="col-6">
                            {{vehiculeNom}}
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-6">
                            Carburant
                        </div>
                        <div class="col-6">
                            <select v-model="carburantId" class="form-control">

                                <option v-for="(carb, key) in filteredCarburant" :key="key" :value="key">
                                    {{ carb }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <br v-if="vehiculeType === 'Camion'"/>
                    <div class="row" v-if="vehiculeType === 'Camion'">
                        <div class="col-6">
                            Compteur
                        </div>
                        <div class="col-6">
                            <input type="number" v-model="compteur" class="form-control">
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-6">
                            Nbr de litres
                        </div>
                        <div class="col-6">
                            <input type="number" v-model="litre" class="form-control">
                        </div>
                    </div>
                    <br/>
                </div>
                <br/>
                <div class="row">
                    <div v-if="show" class="alert alert-info" role="alert">
                        Vous ne pouvez plus modifier cette ligne
                    </div>
                    <div class="col-12 text-center">
                        <button @click="save" v-if="idConsoCarb==null && show==null" class="btn btn-primary">Enregistrer
                        </button>
                        <button @click="save" v-if="idConsoCarb!=null" class="btn btn-primary">Modifier</button>
                        &nbsp;
                        <button @click="videDeclaration(1)" class="btn btn-warning">Annuler</button>
                        &nbsp;
                        <button @click="deleteDeclaration" v-if="idConsoCarb!=null" class="btn btn-danger">Supprimer
                        </button>

                    </div>
                </div>
                <br/>
                <div class="row">

                    <table v-if="listPlein.length" class="table table-striped table-hover table-bordered"
                           cellspacing="0" cellpadding="0">
                        <tr>
                            <th class="thtab">Date</th>
                            <th class="thtab">Type</th>
                            <th class="thtab">Compteur</th>
                            <th class="thtab">Litres</th>
                            <th class="thtab">Chauffeur</th>
                        </tr>
                        <tr v-for="(conso, key) in listPlein" :key="key" @click="openUpdate(conso,2)">
                            <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.date}}
                            </td>
                            <td v-bind:class="{ thtabOrange: showColor==conso.id }">
                                {{listCarburant[conso.carburantTypeId]}}
                            </td>
                            <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.compteur}}</td>
                            <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.litre}}</td>
                            <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.user}}</td>
                        </tr>
                    </table>
                </div>
                <br/>
                <div class="row">
                    <div class="col-12 text-center">
                        <table v-if="listConsoByDate.length" class="table table-striped table-hover table-bordered"
                               cellspacing="0" cellpadding="0">
                            <tr>
                                <th class="thtab">Date</th>
                                <th class="thtab">Type</th>
                                <th class="thtab">Compteur</th>
                                <th class="thtab">Litres</th>
                                <th class="thtab">Chauffeur</th>
                            </tr>
                            <tr v-for="(conso, key) in listConsoByDate" :key="key" @click="openUpdate(conso,1)">
                                <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{afficheDateFr(conso.date)}}
                                    (<span v-if="conso.camion!=null">{{conso.camion.nom}}</span>
                                    <span v-if="conso.remorque!=null">{{conso.remorque.numero}}</span>)
                                </td>
                                <td v-bind:class="{ thtabOrange: showColor==conso.id }">
                                    {{listCarburant[conso.carburantTypeId]}}
                                </td>
                                <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.compteur}}</td>
                                <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.litre}}</td>
                                <td v-bind:class="{ thtabOrange: showColor==conso.id }">{{conso.user}}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="alert alert-danger" role="alert">
                    Vous n'avez pas été trouvé dans la base de données de connexion. Merci de vous rapprocher de votre
                    responsable.
                </div>
            </div>
        </div>
        <div v-else  class="col-12 text-center">
            <button @click="returnNiveau" v-if="niveau!=1" class="btn btn-warning">Annuler</button>
        </div>
        <div class="row">
            <div class="col-6 text-center" v-if="consoGas">
                <div class="alert alert-info" role="alert">Conso gasoil : {{consoGas}}</div>
            </div>
            <div class="col-6 text-center" v-if="consoADB">
                <div class="alert alert-info" role="alert">Conso AD blue : {{consoADB}}</div>
            </div>
        </div>
    </div>
</template>

<script>
    import Aide from './Aide';


    export default {
        name: "DeclarationCarburant",
        props: ['token', 'site', 'user', 'racine', 'userId', 'systemeClient', 'idUser'],
        data() {
            return {
                errors: [], msgs: [], date: null, vehicule: null, vehiculeNom: null, vehiculeType: null,
                idUserLingevres: 0, systemeIdLingevres: 1, afficheCamion: 1, afficheRemorque: 1,
                carburantId: null, compteur: null, litre: null, idConsoCarb: null,
                camion: null, remorque: null, listConsoByDate: [], listCarburant: {1: 'Gazole', 2: 'AD Blue', 3: 'GNR'},
                listCamion: [], listRemorque: [], dateToday: null, show: null, showColor: null,
                niveau: 1, machineType: null, consoGas:null, consoADB:null, listPlein:[],
            };
        },
        methods:
            {
                tokenValide(json) {
                    if (json['status'] == '401') {
                        this.$emit('token')
                    }
                },
                input(input) {
                    console.log(input)
                    this.vehicule = input
                },
                inputNom(input) {
                    console.log(input)
                    this.vehiculeNom = input
                },
                inputType(input) {
                    console.log(input)
                    this.vehiculeType = input
                },

                save() {

                    if (this.carburantId > 0 && (this.compteur > 0 || (this.vehiculeType == "Remorque")) && this.date != null && this.litre > 0 && this.vehicule != null) {

                        if (this.vehiculeType == "Camion") {
                            this.camion = this.vehicule
                            this.remorque = null
                        }
                        else {
                            this.remorque = this.vehicule
                            this.camion = null
                            this.compteur = 1
                        }
                        var camionReq = this.camion
                        if (this.camion != null) {
                            camionReq = "\"" + this.camion + "\""
                        }
                        var remorqueReq = this.remorque
                        if (this.remorque != null) {
                            remorqueReq = "\"" + this.remorque + "\""
                        }
                        console.log(camionReq)
                        console.log(remorqueReq)

                        //on test
                        var myHeaders = new Headers();
                        myHeaders.append("Authorization", "Bearer " + this.token);

                        var formdata = new FormData()
                        formdata.append('date', this.date)
                        formdata.append('carburantTypeId', this.carburantId)
                        formdata.append('compteur', this.compteur)
                        formdata.append('litre', this.litre)
                        formdata.append('remorque', this.remorque)
                        formdata.append('camion', this.camion)
                        formdata.append('idConsoCarb', this.idConsoCarb)
                        formdata.append('created', this.dateToday)

                        /*var requestOptions = {
                            method: 'POST',
                            headers: myHeaders,
                            body: formdata,
                            redirect: 'follow'
                        };*/

                        //var valide = 0
                        var msg = ""
                        /*fetch(this.racine + this.site + 'api/check_value_conso_carburant/', requestOptions)
                            .then(response => response.json())
                            .then(json => {
                                console.log(json);
                                valide = json['valide']
                                msg = json['msg']


                                if (valide == 1) {*/
                                    if (this.idConsoCarb != null) {
                                        fetch(this.racine + this.site + 'api/conso_carburant_chauffeurs/' + this.idConsoCarb, {
                                            method: 'PUT',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': 'Bearer ' + this.token
                                            },
                                            body: "{\"date\":\"" + this.date + "\"," +
                                            "\"carburantTypeId\": " + this.carburantId + "," +
                                            "\"compteur\": " + this.compteur + "," +
                                            "\"litre\": \"" + this.litre + "\"," +
                                            "\"camion\": " + camionReq + "," +
                                            "\"remorque\": " + remorqueReq + "," +
                                            "\"userId\": " + this.idUserLingevres + "," +
                                            "\"created\": \"" + this.dateToday + "\"" +
                                            "}"
                                        }).then(response => response.json())
                                            .then(json => {
                                                console.log(json);
                                                if (json['@type'] == "hydra:Error") {
                                                    this.errors = []
                                                    this.msgs = []
                                                    this.errors.push("Un problème inconnu s'est produit.")
                                                }
                                                else if (json['id'] > 0) {
                                                    this.msgs = []
                                                    this.msgs.push("Votre déclaration a bien été prise en compte.")
                                                    this.videDeclaration(1)
                                                    //this.getConsoByDate()
                                                }
                                                else {
                                                    this.errors = []
                                                    this.msgs = []
                                                    this.errors.push("Un problème inconnu s'est produit.")
                                                }
                                            })
                                    }
                                    else {

                                        fetch(this.racine + this.site + 'api/conso_carburant_chauffeurs', {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json',
                                                'Authorization': 'Bearer ' + this.token
                                            },
                                            body: "{\"date\":\"" + this.date + "\"," +
                                            "\"carburantTypeId\": " + this.carburantId + "," +
                                            "\"compteur\": " + this.compteur + "," +
                                            "\"litre\": \"" + this.litre + "\"," +
                                            "\"camion\": " + camionReq + "," +
                                            "\"remorque\": " + remorqueReq + "," +
                                            "\"userId\": " + this.idUserLingevres + "," +
                                            "\"created\": \"" + this.dateToday + "\"" +
                                            "}"
                                        }).then(response => response.json())
                                            .then(json => {
                                                console.log(json);
                                                if (json['@type'] == "hydra:Error") {
                                                    this.errors = []
                                                    this.msgs = []
                                                    this.errors.push("Un problème inconnu s'est produit.")
                                                }
                                                else if (json['id'] > 0) {
                                                    this.msgs = []
                                                    this.msgs.push("Votre déclaration a bien été prise en compte.")
                                                    this.msgs.push(msg)
                                                    console.log(msg)
                                                    this.videDeclaration(1)
                                                }
                                                else {
                                                    this.errors = []
                                                    this.msgs = []
                                                    this.errors.push("Un problème inconnu s'est produit.")
                                                }
                                            })
                                    }
                                /*}
                                else {
                                    this.errors.push(msg)
                                }
                            })*/
                    }
                    else {
                        this.errors.push("Vous devez remplir tous les champs pour enregistrer.")
                    }


                },
                getUserLingevres() {
                    fetch(this.racine + this.site + 'api/get_id_user_lingevres/' + this.idUser, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.idUserLingevres = json['idUserLingevres']
                                this.getStat()
                            }
                        })
                    })
                },
                getStat() {
                    fetch(this.racine + this.site + 'api/get_conso_recente/' + this.idUserLingevres, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                if(json['valide']==1) {
                                    this.consoGas = json['gasoil']
                                    this.consoADB = json['adblue']
                                }
                            }
                        })
                    })
                },
                /*getConsoByDate() {
                    this.show = null
                    this.showColor = null
                    this.videDeclaration(2)
                    fetch(this.racine + this.site + 'api/conso_carburant_chauffeurs?date=' + this.date + '&userId=' + this.idUserLingevres, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listConsoByDate = json['hydra:member']
                            }
                        })
                    })
                },*/
                deleteDeclaration() {
                    if (this.idConsoCarb != null) {
                        this.$bvModal.msgBoxConfirm('Etes vous sur de vouloir supprimer cette déclaration', {
                            title: 'Etes vous sûr?',
                            size: 'lg',
                            buttonSize: 'lg',
                            okVariant: 'danger',
                            okTitle: 'Oui',
                            cancelTitle: 'Non',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            noFade: true
                        })
                            .then(value => {
                                if (value == true) {
                                    console.log(value)
                                    fetch(this.racine + this.site + 'api/conso_carburant_chauffeurs/' + this.idConsoCarb, {
                                        method: 'DELETE',
                                        headers: {
                                            'Content-Type': 'application/json',
                                            'Authorization': 'Bearer ' + this.token
                                        },
                                    }).then(response => {
                                        this.tokenValide(response)
                                        console.log(response)
                                        if (response.ok == true) {
                                            this.msgs = []
                                            this.msgs.push("La suppression de votre déclaration du " + this.date + " a bien été réalisée.")
                                            this.videDeclaration(1)
                                            this.getConsoByDate()
                                        }
                                    })
                                }
                            })
                    }

                },
                videDeclaration(all) {
                    this.show = null
                    this.showColor = null
                    this.carburantId = null
                    this.compteur = null
                    this.litre = null
                    this.camion = null
                    this.remorque = null
                    this.idConsoCarb = null
                    var self = this
                    if(all==1) {
                        this.vehiculeType = null
                        this.vehicule = null
                        this.vehiculeNom = null
                        this.returnNiveau()
                    }
                    setTimeout(function () {
                        self.errors = []
                        self.msgs = []
                    }, 2000);
                },
                getListCamion() {

                    fetch(this.racine + this.site + 'api/get_tracteur_par_frequence_utilisation_conso/' + this.idUserLingevres + '/' + this.systemeIdLingevres + '/'+this.machineType, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listCamion = json['hydra:member']
                            }
                        })
                    })
                },
                getListRemorque() {
                    fetch(this.racine + this.site + 'api/get_remorque_par_frequence_utilisation_conso_lavage/'+ this.idUserLingevres +'/'+ this.systemeIdLingevres, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listRemorque = json['hydra:member']
                            }
                        })
                    })
                },
                afficheDateFr(dateBDD) {
                    var today = new Date(dateBDD)
                    var month = today.getMonth() + 1
                    var day = today.getDate()
                    if (month < 10) {
                        month = "0" + month
                    }
                    if (day < 10) {
                        day = "0" + day
                    }
                    return day + '/' + month + '/' + today.getFullYear()
                },
                afficheDateUs(dateBDD) {
                    var today = new Date(dateBDD)
                    var month = today.getMonth() + 1
                    var day = today.getDate()
                    if (month < 10) {
                        month = "0" + month
                    }
                    if (day < 10) {
                        day = "0" + day
                    }
                    return today.getFullYear() + '-' + month + '-' + day
                },
                openUpdate(conso,type) {
                    var hier = new Date()
                    hier.setDate(hier.getDate() - 1);

                    this.showColor = conso.id

                    if(type==1) {
                        if ((this.dateToday == this.afficheDateUs(conso.created) || this.afficheDateUs(hier) == this.afficheDateUs(conso.created)) && conso.userId == this.idUserLingevres) {
                            this.idConsoCarb = conso.id
                            this.show = null
                        }
                        else {
                            this.show = conso.id
                            this.idConsoCarb = null
                        }
                        this.remorque = null
                        this.camion = null
                        if (conso.camion != null) {
                            this.vehiculeType = conso.camion['@type']
                            this.vehicule = conso.camion['@id']
                            this.vehiculeNom = conso.camion['nom']
                            this.camion = conso.camion['@id']
                        }
                        else if (conso.remorque != null) {
                            this.vehiculeType = conso.remorque['@type']
                            this.vehicule = conso.remorque['@id']
                            this.vehiculeNom = conso.remorque['numero']
                            this.remorque = conso.remorque['@id']
                        }
                    }
                    else if(type==2) {
                        this.date = conso.dateUS
                        this.idConsoCarb = conso.id
                    }
                    //this.vehiculeType = conso.vehiculeType
                    this.carburantId = conso.carburantTypeId
                    this.compteur = conso.compteur
                    this.litre = conso.litre

                },
                choixMachine(vehicule) {

                    this.listPlein = []
                    this.niveau = 3
                    this.remorque = null
                    this.camion = null

                    var camionId = null
                    var remorqueId = null

                    if(vehicule['@type']=='Camion')
                    {
                        this.vehiculeType = vehicule['@type']
                        this.vehicule = vehicule['@id']
                        this.vehiculeNom = vehicule['nom']
                        this.camion = vehicule['@id']
                        camionId = vehicule['id']
                    }
                    else
                    {
                        this.vehiculeType = vehicule['@type']
                        this.vehicule = vehicule['@id']
                        this.vehiculeNom = vehicule['numero']
                        this.remorque = vehicule['@id']
                        remorqueId = vehicule['id']
                    }


                    fetch(this.racine + this.site + 'api/get_lasts_conso_carb/'+ camionId +'/'+ remorqueId, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + this.token
                        },
                    }).then(response => {
                        this.tokenValide(response)
                        console.log(response)
                        response.json().then(json => {
                            if (json != undefined) {
                                console.log(json)
                                this.listPlein = json['listConso']
                            }
                        })
                    })

                },
                choixMachineType(keyMT) {
                    this.niveau = 2
                    this.machineType = keyMT
                    console.log(keyMT)
                    if (keyMT == 1 || keyMT == 2) {
                        this.getListCamion()
                    }
                    if (keyMT == 3) {
                        this.getListRemorque()
                    }
                },
                returnNiveau()
                {
                    if(this.niveau>1)
                    {
                        this.niveau--
                    }
                }

            },
        mounted() {
            if (this.systemeClient == 1) {
                this.systemeIdLingevres = 2
            }
            else if (this.systemeClient == 2) {
                this.systemeIdLingevres = 1
            }
            this.getUserLingevres()
            var today = new Date()
            this.dateToday = this.afficheDateUs(today)
        },
        created() {
        },
        components: {
            Aide,
        },
        computed: {
            filteredCarburant() {
                // Return filtered list based on vehiculeType
                if (this.vehiculeType === 'Camion') {
                    return Object.fromEntries(
                        Object.entries(this.listCarburant).filter(([key]) => key !== '3')
                    );
                }
                else if (this.vehiculeType === 'Remorque') {
                    return Object.fromEntries(
                        Object.entries(this.listCarburant).filter(([key]) => key === '3' || key === '1')
                    );
                }
                return this.listCarburant;
            }
        }
    }
</script>

<style scoped>

</style>